<template>
<div class="blog-page">
  <HeadNav selectedLanguage="en" page="blog" />

  <main>
    <section class="blog-hero">
      <div>
        <p class="eyebrow">Secure VPN Blog</p>
        <h1>VPN Hot Topics and Resources</h1>
      </div>
    </section>

    <section class="post-list" aria-label="Latest blog posts">
      <a v-for="post in sortedPosts" :key="post.url" :href="post.url" class="post-card">
        <img :src="post.image" :alt="post.title" width="280" height="180">
        <div>
          <span>{{ post.date }}</span>
          <h2>{{ post.title }}</h2>
          <p>{{ post.description }}</p>
        </div>
      </a>
    </section>
  </main>
</div>
</template>

<script>
import '@/css/vpn-theme.scss';
import HeadNav from '@/components/HeadNav.vue';
import { blogPosts } from '@/data/vpnResources.js';

export default {
  name: 'Blog',
  components: {
    HeadNav,
  },
  data() {
    return {
      posts: blogPosts,
    };
  },
  computed: {
    sortedPosts() {
      return [...this.posts].sort((a, b) => new Date(b.date) - new Date(a.date));
    },
  },
};
</script>

<style lang="scss" scoped>
.blog-page {
  min-height: 70vh;
  background: #f7f5ff;
}

main {
  width: var(--vpn-content-width);
  margin: 0 auto;
  padding: 48px 0 72px;
}

.blog-hero {
  padding: 34px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  border-radius: 8px;
  background: #fff;
  box-shadow: var(--vpn-shadow, 0 12px 40px rgba(109, 74, 255, 0.12));
  text-align: center;
}

.eyebrow {
  margin: 0 0 10px;
  color: #198754;
  font-size: 13px;
  font-weight: 800;
  letter-spacing: 0;
  text-transform: uppercase;
}

h1 {
  margin: 0 0 16px;
  color: var(--vpn-ink, #1f2430);
  font-size: 46px;
  line-height: 1.1;
  font-weight: 850;
}

.post-list {
  display: grid;
  gap: 18px;
  margin-top: 28px;
}

.post-card {
  display: grid;
  grid-template-columns: 280px minmax(0, 1fr);
  gap: 22px;
  align-items: center;
  padding: 18px;
  border: 1px solid var(--vpn-line, #e8e4f8);
  border-radius: 8px;
  background: #fff;
  color: inherit;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.post-card:hover {
  transform: translateY(-2px);
  box-shadow: var(--vpn-shadow, 0 12px 40px rgba(109, 74, 255, 0.12));
}

.post-card img {
  width: 100%;
  height: 180px;
  border-radius: 8px;
  object-fit: contain;
  background: #fff;
}

.post-card span {
  display: inline-block;
  margin-bottom: 8px;
  color: #198754;
  font-size: 13px;
  font-weight: 800;
}

.post-card h2 {
  margin: 0 0 10px;
  color: var(--vpn-ink, #1f2430);
  font-size: 26px;
  line-height: 1.25;
}

.post-card p {
  margin: 0;
  color: var(--vpn-ink-muted, #5b6475);
  font-size: 16px;
  line-height: 1.7;
}

@media (max-width: 760px) {
  main {
    width: 100%;
    padding-left: 16px;
    padding-right: 16px;
    box-sizing: border-box;
    padding: 28px 0 48px;
  }

  .post-card {
    grid-template-columns: 1fr;
  }

  .blog-hero {
    padding: 24px;
  }

  h1 {
    font-size: 34px;
  }

  .post-card h2 {
    font-size: 22px;
  }
}
</style>
